import { find, includes } from "lodash";
import React from "react";
import { ImageContent } from "src/app/types/content";
import { IHits } from "src/app/types/pixabay";
import { IconButton } from "..";

export interface IImageGallery {
    imagesList?: Array<IHits>;
    currentSelectedImages?: Array<IHits | ImageContent>;
    handleSelectedImages?(image?: IHits | ImageContent): void;
    removeSelected?: boolean;
    asSideGallery?: boolean;
}

const ImageGallery = (props: IImageGallery) => {
    const {
        imagesList,
        currentSelectedImages,
        handleSelectedImages = () => {},
        asSideGallery = false,
        removeSelected,
    } = props;
    return (
        <div className={`imageGalleryWrapper ${asSideGallery ? "sideGallery" : ""}`}>
            <div className="imagesGallery">
                {imagesList?.map((image, index) => {
                    return (
                        <React.Fragment key={index}>
                            {image.previewWidth / image.previewHeight > 1.25 && (
                                <>
                                    {(!removeSelected ||
                                        !find(
                                            currentSelectedImages,
                                            (img) => img.id === image.id
                                        )) && (
                                        <img
                                            key={index}
                                            onClick={() => handleSelectedImages(image)}
                                            className={
                                                find(
                                                    currentSelectedImages,
                                                    (img) => img.id === image.id
                                                )
                                                    ? "selected"
                                                    : ""
                                            }
                                            src={image.previewUrl}
                                        />
                                    )}
                                </>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
            {asSideGallery && (
                <div className="sidePrevImage">
                    {currentSelectedImages?.map((image, index) => (
                        <div key={index} className="imgWrapper">
                            <div className="iconButtonWrapper">
                                <IconButton
                                    onClick={() => handleSelectedImages(image)}
                                    src="/media/icons/duotune/arrows/arr015.svg"
                                />
                            </div>

                            <img
                                key={index}
                                onClick={() => handleSelectedImages(image)}
                                className={includes(currentSelectedImages, image) ? "selected" : ""}
                                src={image.previewUrl}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ImageGallery;
